.root {
  flex-grow: 1;
  width: 100%;
  background-color: #fff;
}

.paper {
  position: absolute;
  width: 400px;
  background-color: #fff;
  border: 2px solid #000;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
  padding: 24px 32px;
}

.avatar {
  margin: 8px;
  background-color: #f50057;
}

.iconSelector {
  height: 40px;
  width: 40px;
}

.form {
  width: 100%;
  margin-top: 24px;
}

.submit {
  margin: 24px 0 16px;
}

.topMargin {
  margin-top: 32px;
}

.bottomMargin {
  margin-top: 32px;
}

.laborListing {
  width: 100%;
}

.laborListing :global(.MuiInputBase-input.Mui-disabled) {
  -webkit-text-fill-color: #999;
}

.card {
}

.card :global(.MuiTab-textColorPrimary) {
  color: #1976d2;
}

.card :global(.MuiFilledInput-input) {
  font-size: 0.75rem;
}

.card :global(.MuiInputBase-input) {
  font-size: 12px;
}

.card :global(.MuiInputLabel-filled) {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
}

.card :global(.MuiInputLabel-root) {
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
}

.statusNew {
  color: green;
}

.statusError {
  color: red;
}
